# Runs

Every run this browser still holds, newest first. Open one to see it exactly as
it was, under the policy it ran under.

**This is what is still here, not everything that ever ran.** The cache is
bounded and the oldest runs are dropped as new ones arrive, so a run missing
from this list is not a run that never happened.

## The columns

- **Run** is when the analysis happened, taken from the run's own record. A row
  marked *time cached, not run* predates that record and shows when it reached
  the cache instead.
- **Source** is the profile that governed it, with the version. Older rows may
  have none: they were cached before a profile was required for every run.
- **Findings** counts what the quality engine objected to. **Decisions** counts
  the calls recorded against that run.
- **Exported** says whether an artifact was downloaded from this run in this
  browser. It records that a download started — not that the file was kept, or
  that anyone received it.

## Keeping a run

**Keep** pins a run so the routine eviction that makes room for new runs leaves
it alone. A few can be kept at once — a pin exempts a row from eviction, it does
not exempt the cache from having a size, and if every slot could be pinned the
cache would grow until the browser refused to write at all.

One case ignores pins: if the browser refuses a write because storage is full,
the cache is cleared and the write retried. At that point the choice is between
losing pinned runs and caching nothing at all.
